module.exports = __webpack_public_path__ + "img/idcardUrl.920da1fa.png";